import { render, staticRenderFns } from "./platform.vue?vue&type=template&id=04449d23"
import script from "./platform.vue?vue&type=script&lang=js"
export * from "./platform.vue?vue&type=script&lang=js"
import style0 from "./platform.vue?vue&type=style&index=0&id=04449d23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports